<template>
    <div class="wrap">
        <div >
            <Banner></Banner>
        </div>
        <div class="content">
            <div class="title title_1">
                <label>{{congratulation}}</label>
            </div>
            <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/code.png">
            <div class="title space">
                <label>{{title_1}}</label>
            </div>
            <div class="title">
                <label>{{title_2}}</label>
            </div>
            <div class="title">
                <label>{{title_3}}</label>
            </div>
            <div class="toVideo" @click="toVideo">
                <label>{{videoInfo}}</label>
            </div>
            </div>
    </div>
</template>

<script>
    import Banner from "@/components/ksd/fragment/Banner";
    export default {
        name: "RepToken",
        components:{
            Banner
        },
        data(){
            return{
                congratulation:"恭喜您提交成功",
                title_1:"关注微信公众号",
                title_2:"1-2个工作日内",
                title_3:"接收审核提醒消息",
                videoInfo:"返回首页"
            }
        },
        methods:{
            toVideo(){
                this.$router.replace("docStar")
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrap{
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        overflow: scroll;
    }
    .content{
        flex-grow: 1;
        overflow: scroll;
    }
    .content{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0px auto;
    }
    .content .title{
        font-size: 16px;
        font-weight: bold;
        padding-bottom: 5px;
    }
    .content .title_1{
        margin-bottom: 30px;
        color: #2c9a58;
        font-size: 30px;
    }
    .toVideo{
        width: 90%;
        margin-top: 30px;
        border: 1px #2c9a58 solid;
        padding: 5px;
        background: #2c9a58;
        color: #FFF;
        font-size: 16px;
        border-radius: 5px;
    }

    img{
        width: 120px;
        height: 120px;
    }

    .space{
        margin-top: 20px;
    }
</style>